import React from "react";
import LeaveForm from "../../components/features/leaves/LeaveForm";

const CreateLeavePage = () => {
  return <LeaveForm editMode={false} />;
};

export default CreateLeavePage;
